import React from "react";
import { Modal, Button } from "react-bootstrap";
import BackDropLoader from "./BackDropLoader";

const ConfirmationPopup = ({
  show,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  isDeleting = false,
}) => {
  const showLoader =
    isDeleting &&
    (confirmText === "Delete" ||
      confirmText === "Archive" ||
      confirmText === "Unarchive");
  return (
    <>
      {showLoader && <BackDropLoader />}
      <Modal show={show} onHide={onCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-dark" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {confirmText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmationPopup;
